import { Grid } from '@mantine/core';
import { Detail } from '../../../components/Detail';
import { formatToCurrency, formatToThousands } from '../../../util/formatting';
import type { ProductDto } from '../types/ProductDto';

interface SingleProductTileProps {
	isLoading: boolean;
	product: ProductDto | undefined;
}

export function ProductGeneralInfo({
	isLoading,
	product,
}: SingleProductTileProps) {
	return (
		<>
			<Grid w={'100%'}>
				<Grid.Col span={12}>
					<Detail
						isLoading={isLoading}
						label={'Description'}
						stringValue={product?.description}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<Detail
						isLoading={isLoading}
						label={'Model'}
						stringValue={product?.model}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<Detail
						isLoading={isLoading}
						label={'Brand'}
						stringValue={product?.brand}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<Detail
						isLoading={isLoading}
						label={'Group'}
						stringValue={product?.group}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<Detail
						isLoading={isLoading}
						label={'Department'}
						stringValue={product?.department}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'Supplier'}
						stringValue={product?.supplier}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'VAT Rate'}
						stringValue={product?.vatRate}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'Master Barcode'}
						stringValue={product?.barcode}
					/>
				</Grid.Col>
			</Grid>
		</>
	);
}

export function ProductStockCost({
	isLoading,
	product,
}: SingleProductTileProps) {
	return (
		<>
			<Grid>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'Case Cost'}
						stringValue={formatToCurrency(product?.caseCost)}
						isUndefined={product?.singleCost === undefined}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'Case Quantity'}
						stringValue={formatToThousands(product?.caseQuantity)}
						isUndefined={product?.singleCost === undefined}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Detail
						isLoading={isLoading}
						label={'Single Cost'}
						stringValue={formatToCurrency(product?.singleCost)}
						isUndefined={product?.caseCost === undefined}
					/>
				</Grid.Col>
			</Grid>
		</>
	);
}
